import React, { useState, useEffect } from 'react';
//import { EdgeTTSClient, ProsodyOptions, OUTPUT_FORMAT } from 'edge-tts-client';

const data = [
    {
        "group": "English US",
        "voices": [
            {
                "value": "en_us_001",
                "label": "Female - Original"
            },
            {
                "value": "en_female_grandma",
                "label": "Female - Granny"
            },
            {
                "value": "en_us_002",
                "label": "Female - Jessie"
            },
            {
                "value": "en_male_deadpool",
                "label": "Male - Deadpool"
            },
            {
                "value": "en_us_006",
                "label": "Male - Joey"
            },
            {
                "value": "en_us_007",
                "label": "Male - Professor"
            },
            {
                "value": "en_us_009",
                "label": "Male - Scientist"
            },
            {
                "value": "en_us_010",
                "label": "Male - Confidence"
            },
            {
                "value": "en_male_m03_classical",
                "label": "Male - Classic Electric"
            },
            {
                "value": "en_male_jarvis",
                "label": "Male - Alfred"
            },
            {
                "value": "en_male_ashmagic",
                "label": "Male - Ashmagic"
            },
            {
                "value": "en_male_cupid",
                "label": "Male - Cupid"
            },
            {
                "value": "en_male_jomboy",
                "label": "Male - Game On"
            },
            {
                "value": "en_male_ukneighbor",
                "label": "Male - Lord Cringe"
            },
            {
                "value": "en_male_trevor",
                "label": "Male - Marty"
            },
            {
                "value": "en_male_ukbutler",
                "label": "Male - Mr. Meticulous"
            },
            {
                "value": "en_us_ghostface",
                "label": "Male - Scream"
            },
            {
                "value": "en_male_cody",
                "label": "Male - Serious"
            },
            {
                "value": "en_male_narration",
                "label": "Male - Story Teller"
            },
            {
                "value": "en_male_sing_funny_thanksgiving",
                "label": "Male - Thanksgiving"
            },
            {
                "value": "en_male_grinch",
                "label": "Male - Trickster"
            },
            {
                "value": "en_male_funny",
                "label": "Male - Wacky"
            },
            {
                "value": "en_male_wizard",
                "label": "Male - Wizard"
            },
            {
                "value": "en_female_ht_f08_halloween",
                "label": "Halloween Song"
            },
            {
                "value": "en_male_sing_funny_thanksgiving",
                "label": "Thanksgiving Song"
            },
            {
                "value": "en_female_ht_f08_newyear",
                "label": "NYE 2024 Song"
            }
        ]
    },
    {
        "group": "English UK",
        "voices": [
            { "value": "en_uk_001", "label": "Male 1" },
            { "value": "en_uk_003", "label": "Male 2" }
        ]
    },
    {
        "group": "English AU",
        "voices": [
            { "value": "en_au_001", "label": "Female" },
            { "value": "en_au_002", "label": "Male" }
        ]
    },
    {
        "group": "English (Disney & Characters)",
        "voices": [
            { "value": "en_us_ghostface", "label": "Ghostface (Scream)" },
            { "value": "en_us_chewbacca", "label": "Chewbacca (Star Wars)" },
            { "value": "en_us_c3po", "label": "C3PO (Star Wars)" },
            { "value": "en_us_stitch", "label": "Stitch (Lilo & Stitch)" },
            { "value": "en_us_stormtrooper", "label": "Stormtrooper (Star Wars)" },
            { "value": "en_us_rocket", "label": "Rocket (Guardians of the Galaxy)" },
            { "value": "en_female_madam_leota", "label": "Madame Leota" },
            { "value": "en_male_ghosthost", "label": "Ghost Host" },
            { "value": "en_male_pirate", "label": "Pirate" },
            { "value": "en_male_deadpool", "label": "Deadpool" },
            { "value": "en_male_grinch", "label": "The Grinch" },
            { "value": "en_male_wizard", "label": "Wizard" }
        ]
    },
    {
        "group": "English (Singing)",
        "voices": [
            { "value": "en_female_ht_f08_halloween", "label": "Halloween" },
            { "value": "en_female_ht_f08_newyear", "label": "NYE 2024" },
            { "value": "en_female_f08_salut_damour", "label": "Alto" },
            { "value": "en_male_m03_lobby", "label": "Tenor" },
            { "value": "en_male_m03_sunshine_soon", "label": "Sunshine Soon" },
            { "value": "en_female_f08_warmy_breeze", "label": "Warmy Breeze" },
            { "value": "en_female_ht_f08_glorious", "label": "Glorious" },
            { "value": "en_male_sing_funny_it_goes_up", "label": "It Goes Up" },
            { "value": "en_male_m2_xhxs_m03_silly", "label": "Chipmunk" },
            { "value": "en_female_ht_f08_wonderful_world", "label": "Dramatic" },
            { "value": "en_male_sing_funny_thanksgiving", "label": "Thanksgiving" },
            { "value": "en_male_sing_deep_jingle", "label": "Deep Jingle" }
        ]
    },
    {
        "group": "French",
        "voices": [
            { "value": "fr_002", "label": "Male 1" },
            { "value": "fr_001", "label": "Male 2" }
        ]
    },
    {
        "group": "German",
        "voices": [
            { "value": "de_001", "label": "Female" },
            { "value": "de_002", "label": "Male" }
        ]
    },
    {
        "group": "Spanish",
        "voices": [
            { "value": "es_002", "label": "Male (Spain)" },
            { "value": "es_mx_002", "label": "Male (Mexico)" }
        ]
    },
    {
        "group": "Portuguese",
        "voices": [
            { "value": "br_001", "label": "Female 1 (Brazil)" },
            { "value": "br_003", "label": "Female 2 (Brazil)" },
            { "value": "br_004", "label": "Female 3 (Brazil)" },
            { "value": "br_005", "label": "Male (Brazil)" },
            { "value": "bp_female_ivete", "label": "Ivete Sangalo (Portugal)" },
            { "value": "pt_female_laizza", "label": "Laizza (Portugal)" },
            { "value": "pt_male_bueno", "label": "Galvão Bueno (Portugal)" }
        ]
    },
    {
        "group": "Indonesian",
        "voices": [
            { "value": "id_001", "label": "Female" }
        ]
    },
    {
        "group": "Japanese",
        "voices": [
            { "value": "jp_001", "label": "Female 1" },
            { "value": "jp_002", "label": "Female 2" },
            { "value": "jp_005", "label": "Female 3" },
            { "value": "jp_006", "label": "Male" },
            { "value": "jp_female_fujicochan", "label": "りーさ" },
            { "value": "jp_female_hasegawariona", "label": "世羅鈴" }
        ]
    },
    {
        "group": "Korean",
        "voices": [
            { "value": "kr_002", "label": "Male 1" },
            { "value": "kr_004", "label": "Male 2" },
            { "value": "kr_003", "label": "Female" }
        ]
    },
    {
        "group": "Vietnamese",
        "voices": [
            { "value": "BV074_streaming", "label": "Female" },
            { "value": "BV075_streaming", "label": "Male" }
        ]
    },
    // {
    //     "group": "Telugu (India)",
    //     "voices": [
    //         { "value": "te-IN-MohanNeural", "label": "Male" },
    //         { "value": "te-IN-ShrutiNeural", "label": "Female" }
    //     ]
    // },
];

const TextToSpeech = () => {
    const [text, setText] = useState('');
    const [group, setGroup] = useState('English US');
    const [voices, setVoices] = useState([]);
    const [selectedVoice, setSelectedVoice] = useState('');
    const [isConverting, setIsConverting] = useState(false);
    const [audioURL, setAudioURL] = useState('');
    const ENDPOINT = 'https://tiktok-tts.weilnet.workers.dev';
    const MAX_TEXT_LENGTH = 100;

    useEffect(() => {
        if (audioURL) {
            playAudio();
        }
    }, [audioURL]);

    const playAudio = () => {
        const audioElement = document.getElementById('audio');
        if (audioElement) {
            audioElement.play();
        }
    };

    useEffect(() => {
        const initialVoices = data.find(g => g.group === group)?.voices || [];
        setVoices(initialVoices);
        setSelectedVoice(initialVoices[0]?.value || '');
    }, [group]);

    const handleGroupChange = (event) => {
        setGroup(event.target.value);
    };

    const handleVoiceChange = (event) => {
        setSelectedVoice(event.target.value);
    };

    const handleTextChange = (event) => {
        setText(event.target.value);
    };

    const  handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const fr = new FileReader();
            fr.onload = () => {
                setText(fr.result);
            };
            fr.readAsText(file);
        }
    };

    const handleRefresh = () => {
        setText('');
    };

    const handleCopy = () => {
        navigator.clipboard.writeText(text).then(() => {
            alert("Success! Copied successfully. Please paste anywhere.");
        }).catch(err => {
            console.error('Failed to copy: ', err);
        });
    };

    const handleDownload = () => {
        const blob = new Blob([text], { type: 'text/plain;charset=utf-8' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'text.txt';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    
    const generateAudio = async (text, voice) => {
        const response = await fetch(`${ENDPOINT}/api/generation`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ text, voice }),
        });
        const data = await response.json();
        return data.data;
    };

    // const synthesizeText = async () => {
    //     try {
    //         if (!text) {
    //             alert("Please enter some text.");
    //             return;
    //         }
    //         setIsConverting(true);
    //         const ttsClient = new EdgeTTSClient();
    //         await ttsClient.setMetadata(selectedVoice, OUTPUT_FORMAT.AUDIO_24KHZ_48KBITRATE_MONO_MP3);
    
    //         const options = new ProsodyOptions();
    //         options.pitch = 'medium'; // adjust as needed
    //         options.rate = 1.0; // adjust as needed
    //         options.volume = 90; // adjust as needed
    
    //         const audioChunks = [];
    //         const stream = ttsClient.toStream(text, options);
    
    //         stream.on('data', (audioChunk) => {
    //             if (audioChunk) {
    //                 audioChunks.push(audioChunk);
    //             } else {
    //                 console.warn("Received an undefined audio chunk");
    //             }
    //         });
    
    //         stream.on('end', () => {
    //             if (audioChunks.length > 0) {
    //                 const audioBlob = new Blob(audioChunks, { type: 'audio/mp3' });
    //                 const url = URL.createObjectURL(audioBlob);
    //                 setAudioURL(url);
    //             } else {
    //                 alert("No audio data received.");
    //             }
    //             setIsConverting(false);
    //         });
    
    //         stream.on('error', (error) => {
    //             console.error('Error during synthesis:', error);
    //             alert("An error occurred during synthesis. Please try again.");
    //         });
    //     } catch (error) {
    //         console.error('Unexpected error:', error);
    //         //alert("An unexpected error occurred. Please try again.");
    //     }
    // };

    const splitTextIntoChunks=async(text, maxLength = 100)=> {
        const parts = [];
        let current = '';

        for (const sentence of text.split(/([.?!])\s+/)) {
            if (!sentence.trim()) continue; // bỏ rỗng ngay từ đầu

            if ((current + sentence).length > maxLength) {
            if (current.trim()) parts.push(current.trim());
            current = sentence;
            } else {
            current += (current ? ' ' : '') + sentence;
            }
        }

        if (current.trim()) parts.push(current.trim());

        return parts;
    }
    
    const processText = async () => {
        setAudioURL('');
        // if (group === "Telugu (India)") {
        //     await synthesizeText();
        //     return; // Exit after synthesis for Telugu
        // }
        setIsConverting(true);
        //const textParts = text.match(new RegExp(`.{1,${MAX_TEXT_LENGTH}}`, 'g')) || [];
        
        const textParts = await splitTextIntoChunks(text,MAX_TEXT_LENGTH)
        // Use Promise.all to generate audio for all text parts concurrently
        const audioDataParts = await Promise.all(
            textParts.map(part => generateAudio(part, selectedVoice))
        );

        if (audioDataParts.length === textParts.length) {
            const audioBlob = new Blob(
                audioDataParts.map(data => new Uint8Array(atob(data).split("").map(c => c.charCodeAt(0)))),
                { type: 'audio/mpeg' }
            );

            const url = URL.createObjectURL(audioBlob);
            setAudioURL(url);
        }
        setIsConverting(false);
    };

    const handleConvertAudio = async () => {
        if (text.trim() === "") {
            alert("Please enter some text.");
            return;
        }
        //setIsConverting(true);
        await processText();
        //setIsConverting(false);
    };

    const handleDownloadAudio = async () => {
        if (audioURL.length === 0) {
            alert("Please convert before downloading.");
            return;
        }
        downloadAudio();
    };
    const downloadAudio = () => {
        const a = document.createElement('a');
        a.href = audioURL;
        a.download = 'audio.mp3'; // Set the desired file name
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
    

    return (
        <div className="my-3 card">
            <div className="card">
                <div id="action-button-container">
                    <button className="btn btn-outline-primary custom-file-uploader" title="Import Text">
                        <input id="inputfile" type="file" onChange={handleFileChange} style={{ display: 'none' }} />
                        <span onClick={() => document.getElementById('inputfile').click()}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-folder-plus" viewBox="0 0 16 16">
                                <path d="m.5 3 .04.87a1.99 1.99 0 0 0-.342 1.311l.637 7A2 2 0 0 0 2.826 14H9v-1H2.826a1 1 0 0 1-.995-.91l-.637-7A1 1 0 0 1 2.19 4h11.62a1 1 0 0 1 .996 1.09L14.54 8h1.005l.256-2.819A2 2 0 0 0 13.81 3H9.828a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 6.172 1H2.5a2 2 0 0 0-2 2zm5.672-1a1 1 0 0 1 .707.293L7.586 3H2.19c-.24 0-.47.042-.683.12L1.5 2.98a1 1 0 0 1 1-.98h3.672z" />
                                <path d="M13.5 10a.5.5 0 0 1 .5.5V12h1.5a.5.5 0 1 1 0 1H14v1.5a.5.5 0 1 1-1 0V13h-1.5a.5.5 0 0 1 0-1H13v-1.5a.5.5 0 0 1 .5-.5z" />
                            </svg>
                        </span>
                    </button>
                    <button className="btn btn-outline-primary btn-refresh" title="Refresh" onClick={handleRefresh}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-repeat" viewBox="0 0 16 16">
                            <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z" />
                            <path fillRule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z" />
                        </svg>
                    </button>
                    <button className="btn btn-outline-primary btn-copy" title="Copy" onClick={handleCopy}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-clipboard" viewBox="0 0 16 16">
                            <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" />
                            <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />
                        </svg>
                    </button>
                    <button className="btn btn-outline-primary btn-download" title="Download Text" onClick={handleDownload}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-save" viewBox="0 0 16 16">
                            <path d="M2 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H9.5a1 1 0 0 0-1 1v7.293l2.646-2.647a.5.5 0 0 1 .708.708l-3.5 3.5a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L7.5 9.293V2a2 2 0 0 1 2-2H14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h2.5a.5.5 0 0 1 0 1H2z" />
                        </svg>
                    </button>
                </div>
            </div>
            <div className="form-group">
                <textarea
                    className="form-control"
                    id="texto"
                    name="texto"
                    placeholder="Paste Text..."
                    rows="10"
                    value={text}
                    onChange={handleTextChange}
                />
            </div>
            <div className="row m-3">
                <div className="col-lg-4">
                    <div className="row">
                        <div className="col-lg-6">
                            <select className="form-select border-primary mt-2" id="group-select" onChange={handleGroupChange}>
                                {data.map(group => (
                                    <option key={group.group} value={group.group}>{group.group}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-lg-6">
                            <select className="form-select border-primary mt-2" id="voice-select" value={selectedVoice} onChange={handleVoiceChange}>
                                {voices.map((voice, index) => (
                                    <option key={`${voice.value}-${index}`} value={voice.value}>
                                        {voice.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3">
                    <button className="btn btn-primary mt-2" onClick={handleConvertAudio}>
                        {isConverting ? "Converting..." : "Convert"}
                    </button>
                </div>
                <div className="col-lg-3">
                    <audio className="float-end" id="audio" controls src={audioURL} />
                </div>
                <div className="col-lg-2">
                    <button className="btn btn-outline-primary mt-2" onClick={handleDownloadAudio}>
                        Download
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TextToSpeech;
